import React from 'react';
import Modal from '../Modal';
import Button from '../Button';

import styles from './RemoveAddressModal.module.scss';

interface RemoveAddressModalProps {
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2?: string;
  zipcode: string;
  city: string;
  state: string;
  country: string;
  isOpen: boolean;
  onRemove: () => void;
  onCancel: () => void;
}

const RemoveAddressModal: React.FC<RemoveAddressModalProps> = ({
  firstName,
  lastName,
  addressLine1,
  addressLine2,
  zipcode,
  city,
  state,
  country,
  isOpen,
  onRemove,
  onCancel,
}) => (
  <Modal isOpen={isOpen} style={{ padding: 0 }}>
    <div className={styles.container}>
      <h1>Remove Address</h1>
      <p>
        <strong>
          {firstName} {lastName}
        </strong>
      </p>
      <p>
        {addressLine1}
        {addressLine2 ? `, ${addressLine2}` : ''}
      </p>
      <p>
        {city}, {state} {zipcode}
      </p>
      <p>{country}</p>
      <span>
        <strong>Please note:</strong> Removing this address will not affect any pending orders being
        shipping to this address.
      </span>
      <div className={styles.buttonsContainer}>
        <Button variation="black-outline" onClick={onCancel}>
          {' '}
          CANCEL{' '}
        </Button>
        <Button variation="black" onClick={onRemove}>
          {' '}
          REMOVE{' '}
        </Button>
      </div>
    </div>
  </Modal>
);

export default RemoveAddressModal;
